module.exports = __webpack_public_path__ + "static/media/blog16.249f9fdf.svg";